<template>
            <div v-if="sectionLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
            <div v-if="sectionError" class="mc-error">{{ brandError }}</div>
  <div v-if="sectionLoaded" class="cr-catalog__categories">
    <SearchForm></SearchForm>
    <ul class="cr-catalog__categories-list">
      <li v-for="section in sections" class="cr-catalog__categories-item">
        <a class="cr-category-card cr-category-card--bg-image" href="#">
          <div class="cr-category-card__body">
            <router-link :to="'/category/'+section.id+'/'" class="cr-category-card__title">
              {{section.name}}
            </router-link>
            <dl v-if="section.children.length > 0" class="cr-category-card__list">
              <template v-for="item in section.children">
                <router-link :to="'/category/'+item.id+'/'" class="cr-category-card__item">
                  <dt class="cr-category-card__term">
                    {{ item.name }}
                  </dt>
                  <dd v-if="item.quantity" class="cr-category-card__value">
                    {{ item.quantity }}
                  </dd>
                </router-link>
              </template>
            </dl>
          </div>
          <img v-if="section.picture" class="cr-category-card__image" :src="section.picture" width="50" height="50" alt="">
        </a>
      </li>
    </ul>
  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SearchForm from "@/views/components/SearchForm.vue";

export default {
  data: () => ({


  }),
  created() {
    this.fetchSection();
  },
  computed: {
    ...mapGetters('section', [
      'sections',
      'sectionLoading',
      'sectionError',
      'sectionLoaded'
    ]),
    filteredBrands() {
      return this.filterBrands();
    }

  },
  components: {SearchForm},
  methods: {
    ...mapActions('section', [
      'fetchSection'
    ]),
    doSearch(evt) {
      this.searchQuery = evt.target.value;
    },
    filterBrands() {
      if (!this.searchQuery) return this.brand;

      const result = {};

      for (const [letter, brands] of Object.entries(this.brand)) {
        const filteredBrands = brands.brands.filter(brand => {

              return brand.name.toLowerCase().includes(this.searchQuery.toLowerCase())
            }
        );
        if (filteredBrands.length > 0) {
          if (!result[letter])
            result[letter] = {
              letter: letter,
              brands: []
            };
          result[letter].brands = filteredBrands;
        }
      }

      return result;
    },
    clearSearch() {
      this.searchQuery = '';
    },


  },
}
</script>

